import { render, staticRenderFns } from "./text-row-rating.vue?vue&type=template&id=0f0c042f&"
import script from "./text-row-rating.vue?vue&type=script&lang=js&"
export * from "./text-row-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0c042f')) {
      api.createRecord('0f0c042f', component.options)
    } else {
      api.reload('0f0c042f', component.options)
    }
    module.hot.accept("./text-row-rating.vue?vue&type=template&id=0f0c042f&", function () {
      api.rerender('0f0c042f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-rating.vue"
export default component.exports